import React from 'react';
import { motion } from 'framer-motion';
import govtImg from '../images/photos/government.jpg'; // replace with your actual image path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_GovernmentPublic = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Government & Public
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={govtImg}
          alt="Government and Public sector"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Smart Solutions for Better Governance and Public Service. Zyntro Software Solutions Pvt. Ltd.
          is dedicated to empowering government and public sector organizations with innovative
          technology solutions that enhance efficiency, transparency, and service delivery. We
          specialize in providing digital transformation strategies, data management systems, and
          automated solutions to support government agencies, municipalities, and public institutions
          in managing their operations effectively.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Our solutions help streamline workflows, improve citizen engagement, and drive smarter
          decision-making by integrating advanced technologies such as cloud computing, data
          analytics, and AI. From e-Governance platforms and public service applications to security
          solutions and compliance systems, we provide tailored solutions to meet the unique needs of
          government and public sector entities.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          With Zyntro Software Solutions Pvt. Ltd., public organizations can enhance operational
          efficiency, deliver better services, and foster greater accountability and transparency for
          the public they serve.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_GovernmentPublic;
